import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, Flame } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const { cfg } = useTheme();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      toast.success("Bienvenido, admin");
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Error de autenticación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-4 grain relative">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6">
          <div className="w-10 h-10 rounded-md bg-brand flex items-center justify-center rotate-[-6deg]">
            <Flame className="w-5 h-5 text-black" strokeWidth={3} />
          </div>
          <div className="font-heading text-3xl text-white uppercase">{cfg?.nombreLocal || "Panel"}</div>
        </Link>
        <div data-testid="admin-login-form" className="bg-panel border border-line rounded-xl p-6 sm:p-8 slide-up">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-5 h-5 text-gold" />
            <h1 className="font-heading text-2xl uppercase text-white">Panel Admin</h1>
          </div>
          <form onSubmit={submit} className="space-y-3">
            <label className="block">
              <span className="text-[11px] uppercase tracking-widest text-zinc-400 font-bold">Email</span>
              <input
                data-testid="admin-email-input"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                placeholder="tu@email.com"
                className="mt-1 w-full bg-black border border-line focus:border-brand rounded px-3 py-2.5 text-sm text-white placeholder:text-zinc-600 outline-none"
              />
            </label>
            <label className="block">
              <span className="text-[11px] uppercase tracking-widest text-zinc-400 font-bold">Contraseña</span>
              <input
                data-testid="admin-password-input"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                placeholder="••••••••"
                className="mt-1 w-full bg-black border border-line focus:border-brand rounded px-3 py-2.5 text-sm text-white placeholder:text-zinc-600 outline-none"
              />
            </label>
            {error && <div data-testid="admin-login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded p-2">{error}</div>}
            <button
              data-testid="admin-login-submit"
              disabled={loading}
              type="submit"
              className="w-full flex items-center justify-center gap-2 bg-brand hover:bg-brand-strong disabled:bg-zinc-700 text-black font-black uppercase tracking-widest py-3 rounded transition-colors"
            >
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Ingresando...</> : "Ingresar"}
            </button>
          </form>
          <p className="mt-4 text-xs text-zinc-600 text-center">Solo para el dueño del local.</p>
        </div>
      </div>
    </div>
  );
}
